export const THEME_TRANSITION_CLASS = 'themeChanging'
export const THEME_TRANSITION_MS = 250

export const startThemeTransition = (): void => {
  document.documentElement.classList.add(THEME_TRANSITION_CLASS)
}

export const endThemeTransition = (): void => {
  document.documentElement.classList.remove(THEME_TRANSITION_CLASS)
}
